import { FieldProps } from '@rjsf/utils';

import Checkbox from 'design-system/components/Checkbox';

export function PDSCheckBoxField({
  formData,
  name,
  disabled,
  onChange,
  schema,
  uiSchema,
}: FieldProps) {
  return (
    <Checkbox
      id={name}
      checked={formData}
      disabled={disabled}
      label={schema.description || uiSchema?.['ui:description']}
      onChange={(event) => onChange(event.target.checked)}
    />
  );
}
